module.exports = __webpack_public_path__ + "img/carrusel_01.98f3ad76.jpg";